module.exports = __webpack_public_path__ + "media/images/landing/icons/tiktok-f68e8c8f84211a5aa18619275a6514f2.svg";